import {ActivatedRouteSnapshot, Routes} from "@angular/router";
import {HomeComponent} from "./components/home/home.component";
import {LayoutComponent} from "./components/layout/layout.component";
import {ShortlinkContainerComponent} from "./components/shortlink-container/shortlink-container.component";
import {inject} from '@angular/core';
import {PageConfigurationService} from './core/services/page-configuration.service';
import {LayoutService} from './components/layout/layout.service';
import {PageConfigurationResponse} from './core/types/page-configuration.types';
import {tap} from 'rxjs';
import {OneTimeCodeComponent} from "./components/one-time-code/one-time-code.component";
import {NoActiveChangeOrderComponent} from "./components/no-active-change-order/no-active-change-order.component";
import {GtmService} from './google-tag-manager/gtm.service';
import {environment} from '../environments/environment';

const pageConfigurationResolver = (route: ActivatedRouteSnapshot) => {
    const configurationService = inject(PageConfigurationService);
    const layoutService = inject(LayoutService);
    const gtmService = inject(GtmService);
    const shortLink = route.params["shortLink"];

    return configurationService.getConfiguration(shortLink)
        .pipe(
            tap((response: PageConfigurationResponse) => {
                if (response.success) {
                    layoutService.setColorScheme(response.data!.colorScheme);
                    layoutService.setLogoSrc(`${environment.apiSettings.baseUrl}/${environment.apiSettings.version}/page-configurations/${shortLink}/logo`);
                    layoutService.setBrokerInfo(response.data!.broker);

                    if (response.data?.tenantId === 476) {
                        gtmService.load('GTM-58B9X92P');
                    }
                }
            })
        );
}

export const routes: Routes = [
    {
        path: "",
        component: LayoutComponent,
        children: [
            {
                path: "",
                component: HomeComponent,
            },
            {
                path: "no-co",
                component: NoActiveChangeOrderComponent,
            },
            {
                path: ":shortLink",
                component: ShortlinkContainerComponent,
                resolve: {
                    pageConfiguration: pageConfigurationResolver
                }
            },
            {
                path: ":shortLink/:oneTimeCode",
                component: OneTimeCodeComponent
            }
        ],
    },
];
